var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"float":"right"}},[_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":"/xr","id":"","type":"button"}},[_vm._v("\n        Launch LifeChain XR\n    ")])]),_c('img',{attrs:{"src":require("../../assets/images/xr.png")}})])
}]

export { render, staticRenderFns }